module.exports = __webpack_public_path__ + "ceaa6a5f843864715567cdfea47e781e.jpg";